import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/Home.vue'
import MallPage from '../views/Mall.vue'
import AboutUs from '@/views/AboutUs.vue'
import UserLogin from '@/views/Login.vue'
// import ProductCustomDetail from '../views/ProductCustomDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/mall',
    name: 'MallPage',
    component: MallPage
  },
  {
    path: '/login',
    name: 'Login',
    component: UserLogin
  },
  {
    path: '/detail/custom/:id',
    name: 'ProductCustomDetail',
    component: () => import('../views/ProductCustomDetail.vue')
  },
  {
    path: '/detail/product/:id',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetail.vue')
  },
  {
    path: '/category-list',
    name: 'CategoryList',
    component: () => import('@/views/CategoryList.vue')
  },
  {
    path: '/cart',
    name: 'CartPage',
    component: () => import('@/views/Cart.vue')
  },
  {
    path: '/user-profile',
    name: 'UserProfile',
    component: () => import('@/views/UserProfile.vue')
  },
  {
    path: '/order-confirm',
    name: 'OrderConfirm',
    component: () => import('@/views/OrderConfirm.vue')
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUs
  },
  {
    path: '/order-detail/:orderId',
    name: 'OrderDetail',
    component: () => import('@/views/OrderDetail.vue')
  },
  {
    path: '/recharge',
    name: 'RechargePage',
    component: () => import('@/views/Recharge.vue')
  },
  {
    path: '/customization',
    name: 'CustomizationPage',
    component: () => import('@/views/Customization.vue')
  },
  {
    path: '/blank',
    name: 'BlankPage',
    component: () => import('@/views/Blank.vue')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/PrivacyPolicy.vue')
  },
  {
    path: '/ios_links',
    name: 'IosLinks',
    component: () => import('@/views/H5/IosLinks.vue')
  },
  {
    path: '/model-preview',
    name: 'Model3DPreview',
    component: () => import('@/views/H5/Model3DPreview.vue')
  },
  {
    path: '/qO7J2gtvdS.txt',
    name: 'MPVerify',
    component: () => import('@/views/H5/MPVerify.vue')
  },
  {
    path: '/MP_verify_MDyUzBYSYZniLGbu.txt',
    name: 'MPVerify3',
    component: () => import('@/views/H5/MPVerify3.vue')
  },
  {
    path: '/friend-payment',
    name: 'FriendPayment',
    component: () => import('@/views/H5/FriendPayment.vue')
  },
  {
    path: '/image-upload',
    name: 'ImageUpload',
    component: () => import('@/views/H5/ImageUpload.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router 